import { render } from "./Payment.vue?vue&type=template&id=d2249810&scoped=true"
import script from "./Payment.vue?vue&type=script&lang=js"
export * from "./Payment.vue?vue&type=script&lang=js"

import "./custom-payment.scss?vue&type=style&index=0&id=d2249810&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2249810"]])

export default __exports__